<template>
  <Layout :cssType="1">
    <template #top>
      <div class="overview-head">

        <Head ref="incomeHead" :searchConfig="tableData.searchConfig" @searchData="searchData" />
      </div>
    </template>
    <template>
      <div class="overview-chart" v-loading="isLoading">
        <Chart defaultTarget="fb_ad_network_revenue" :userData="chartData" :dataType="this.selectType"
          :userTotalData="this.chartTotalData"></Chart>
        <Chart defaultTarget="fb_ad_network_cpm" :userData="chartData" :dataType="this.selectType"
          :userTotalData="this.chartTotalData"></Chart>
        <Chart defaultTarget="fb_ad_network_request" :userData="chartData" :dataType="this.selectType"
          :userTotalData="this.chartTotalData"></Chart>
        <Chart defaultTarget="fb_ad_network_imp" :userData="chartData" :dataType="this.selectType"
          :userTotalData="this.chartTotalData"></Chart>
      </div>
      <div class="overview-table">
        <h1>表现数据细分</h1>
        <div class="overview-table-select">
          <div v-for="item in breakdownsConfig" :key="item.label" :class="{ selected: params.breakdown === item.prop }"
            @click="
              () => {
                changeBreakdown(item);
              }
            ">
            {{ item.label }}
          </div>
        </div>

        <Body ref="table" :headConfig="tableData.headConfig" :tableData="data" @select-change="selectChange"
          @sort-change="sortChange" v-loading="isLoadingTable" />
      </div>
    </template>
  </Layout>
</template>

<script>
import getBusiness from "@/api/getBusiness.js";
import criteriaQueryBusiness from "@/api/criteriaQueryBusiness.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import Chart from "@/components/Chart";
import requstData from "@/mixins/requstData.js";
import {
  getLATime,
  getSameDay,
  getDay,
  getTimeRange,
  getBJTime,
  getTimeToLA,
  getLaToZero,
} from "@/utils/time.js";
import { valueFormat } from "@/utils/formatBigNum.js";
import getCountryName from "@/utils/getCountryName.js";

export default {
  mixins: [requstData([])],
  components: {
    Layout,
    Head,
    Body,
    Foot,
    Chart,
  },
  data() {
    const displayFormat = [
      { label: "横幅广告", value: "BANNER" },
      { label: "插屏广告", value: "INTERSTITIAL" },
      { label: "激励视频", value: "REWARDED_VIDEO" },
      { label: "激励插屏广告", value: "REWARDED_INTERSTITIAL" },
    ];
    return {
      businessData: [],
      displayFormat,
      tableData: {
        headConfig: {
          select: false,
          key: "id",
          list: [
            { label: "日期", prop: "title", width: "250" },
            {
              label: "广告请求次数",
              prop: "fb_ad_network_request",
              width: "150",
            },
            { label: "展示次数", prop: "fb_ad_network_imp", width: "150" },
            {
              label: "展示率",
              prop: "fb_ad_network_impression_rate",
              width: "120",
            },
            { label: "点击量", prop: "fb_ad_network_click", width: "120" },
            { label: "点击率", prop: "fb_ad_network_ctr", width: "120" },
            { label: "eCPM", prop: "fb_ad_network_cpm", width: "120" },
            { label: "预估收入", prop: "fb_ad_network_revenue" },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "date",
              model: "date",
              setting: {
                pickerOptions: {
                  disabledDate: getDay(getLATime(), 1),
                  shortcuts: [
                    {
                      text: "当天",
                      onClick: (picker) => {
                        this.selectType = "day";
                        return picker.$emit("pick", [
                          getDay(getLATime()),
                          getDay(getLATime(), 1) - 1000,
                        ]);
                      },
                    },
                    {
                      text: "过去24小时",
                      onClick: (picker) => {
                        this.selectType = "hour";
                        return getTimeRange(
                          picker,
                          24,
                          getLATime(true) - 1 * 3600 * 1000
                        );
                      },
                    },
                    {
                      text: "过去45小时",
                      onClick: (picker) => {
                        this.selectType = "hour";
                        return getTimeRange(
                          picker,
                          45,
                          getLATime(true) - 1 * 3600 * 1000
                        );
                      },
                    },
                    {
                      text: "过去7天",
                      onClick: (picker) => {
                        this.selectType = "range";
                        return getTimeRange(
                          picker,
                          24 * 7,
                          getDay(getLATime())
                        );
                      },
                    },
                  ],
                  onPick: ({ maxDate, minDate }) => {
                    if (maxDate && minDate) {
                      const maxTime = new Date(maxDate).getTime();
                      const minTime = new Date(minDate).getTime();
                      this.selectType = maxTime - minTime ? "range" : "day";
                    }
                  },
                  cellClassName: (a) => {
                    const now = getLATime();
                    const date = new Date(a).getTime();
                    return getSameDay(date, now)
                      ? "la-time-today"
                      : "la-time-default";
                  },
                },
              },
              span: 5,
            },
            {
              type: "select",
              model: "property",
              span: 4.5,
              placeholder: "所有资产",
              setting: {
                multiple: false,
              },
              options: [],
            },
            {
              type: "select",
              model: "country",
              span: 4.5,
              placeholder: "所有国家/地区",
              setting: {
                multiple: true,
              },
              options: [
                { label: "台湾", value: "TW" },
                { label: "香港", value: "HK" },
                { label: "新加坡", value: "SG" },
                { label: "菲律宾", value: "PH" },
                { label: "马来西亚", value: "MY" },
                { label: "印度尼西亚", value: "ID" },
                { label: "日本", value: "JP" },
                { label: "越南", value: "VN" },
                { label: "泰国", value: "TH" },
                { label: "英国", value: "GB" },
                { label: "美国", value: "US" },
                { label: "德国", value: "DE" },
                { label: "南非", value: "ZA" },
                { label: "加拿大", value: "CA" },
                { label: "澳大利亚", value: "AU" },
                { label: "尼日利亚", value: "NG" },
                { label: "沙特阿拉伯", value: "SA" },
                { label: "美国本土外小岛屿", value: "UM" },
              ],
            },
            {
              type: "select",
              model: "display_format",
              span: 4.5,
              placeholder: "所有展示格式",
              setting: {
                multiple: true,
              },
              options: displayFormat,
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
              ],
            },
          ],
        },
      },
      breakdownsConfig: [
        {
          label: "资产",
          prop: "property",
        },
        {
          label: "国家/地区",
          prop: "country",
        },
        {
          label: "展示格式",
          prop: "display_format",
        },
        {
          label: "日期",
          prop: "date",
        },
      ],
      params: {
        breakdown: "date",
        filters: [],
      },
      chartData: {},
      chartTotalData: {},
      tableList: {},
      selectParams: {},
      isLoadingTable: false,
      selectType: "hour",
    };
  },
  methods: {
    async requst(params) {
      if (!this.businessData.length) {
        let res = await getBusiness();
        if (res && res.length > 0) {
          this.businessData = res;
          this.tableData.searchConfig.list[1].options = res.map((item) => {
            return {
              label: item.appName,
              value: item.appId,
            };
          });
          this.selectType = "hour";
          const time = getTimeRange(
            null,
            24,
            getLATime(true) - 2 * 3600 * 1000
          );
          this.$refs.incomeHead.setDataInfo("date", time);
          this.$refs.incomeHead.setDataInfo("property", res[0].appId);
          return await this.getRequest({
            ...params,
            ...{
              property: res[0].appId,
              startSendTime: time[0],
              endSendTime: time[1],
            },
          });
        }
      } else {
        return await this.getRequest(params);
      }
    },
    async getRequest(params) {
      let obj = {
        appId: "",
        aggregationPeriod: "total",
        filters: "[]",
        metrics: JSON.stringify([
          "fb_ad_network_cpm",
          "fb_ad_network_no_fill",
          "fb_ad_network_ctr",
          "fb_ad_network_filled_request",
          "fb_ad_network_bidding_bid_rate",
          "fb_ad_network_bidding_request",
          "fb_ad_network_bidding_win_rate",
          "fb_ad_network_imp",
          "fb_ad_network_click",
          "fb_ad_network_fast_click_denominator",
          "fb_ad_network_fast_return_rate",
          "fb_ad_network_fast_click_numerator",
          "fb_ad_network_bidding_response",
          "fb_ad_network_request",
          "fb_ad_network_impression_rate",
          "fb_ad_network_fast_click_rate",
          "fb_ad_network_fast_return_denominator",
          "fb_ad_network_revenue",
          "fb_ad_network_fill_rate",
          "fb_ad_network_fast_return_numerator",
          "fb_ad_network_no_bid",
        ]),
        since: "",
        until: "",
      };
      let filters = [];
      for (let key in params) {
        const value = params[key];
        switch (true) {
          case key === "country" && value.length > 0:
            filters.push({ field: "country", operator: "IN", values: value });
            break;
          case key === "display_format" && value.length > 0:
            filters.push({
              field: "display_format",
              operator: "IN",
              values: value,
            });
            break;
          case key === "property":
            obj.appId = value;
            var propertyId = this.businessData.find(
              (a) => a.appId === value
            ).assetId;
            filters.push({
              field: "property",
              operator: "IN",
              values: [propertyId],
            });
            break;
          case key === "startSendTime":
            obj.since = getBJTime(value) / 1000;
            break;
          case key === "endSendTime":
            obj.until = getBJTime(value) / 1000;
            break;
        }
      }
      obj.filters = JSON.stringify(filters);

      obj.aggregationPeriod = this.selectType === "hour" ? "hour" : "day";

      this.selectParams = obj;
      let res = await criteriaQueryBusiness(obj);
      let resTotal = await criteriaQueryBusiness({
        ...obj,
        ...{ aggregationPeriod: "total" },
      });
      if (res && res.length > 0) {
        const { tableData, chartData } = this.initData(res, obj);
        this.chartData = chartData;
        this.tableList = { date: tableData };
        this.changeBreakdown(
          this.breakdownsConfig[this.breakdownsConfig.length - 1]
        );
        this.initTotalData(chartData, "hour");
      } else {
        this.chartData = [];
        this.tableList = { date: [] };
        this.changeBreakdown(
          this.breakdownsConfig[this.breakdownsConfig.length - 1]
        );
        this.chartTotalData = {};
      }
      if (obj.aggregationPeriod !== "hour" && resTotal && resTotal.length > 0) {
        this.initTotalData(resTotal, "day");
      }
    },
    initData(data, obj) {
      const allTimes = [];
      const tableData = [];
      let hourDiff = 0;
      let userData = [];

      if (this.selectType === "day") {
        userData = data.filter(({ time }) => {
          return (
            new Date(time).getDate() >= new Date(obj.since * 1000).getDate()
          );
        });
      } else {
        userData = data;
      }

      userData.forEach(({ time, breakdowns }) => {
        const key = breakdowns ? breakdowns[0].value : time;
        if (!allTimes.includes(key)) {
          allTimes.unshift(key);
        }
      });

      if (obj.aggregationPeriod === "hour") {
        const hourNow = new Date(getLATime(true) - 2 * 3600 * 1000);
        const timeData = new Date(
          getTimeToLA(new Date(allTimes[allTimes.length - 1]).getTime())
        );
        hourDiff = Math.floor(Math.abs(hourNow - timeData) / (1000 * 60 * 60));
        if (hourDiff) {
          for (let i = 0; i < hourDiff; i++) {
            allTimes.push(getLaToZero(timeData, i + 1));
          }
        }
      }
      const chartData = userData.reduce(
        (acc, { metric, time, value, breakdowns }) => {
          const key = breakdowns ? breakdowns[0].value : time;
          if (!acc[metric]) {
            acc[metric] = { date: [], value: [] };
          }
          allTimes.forEach((t, index) => {
            if (!acc[metric].date.includes(t)) {
              acc[metric].date[index] = t;
              acc[metric].value[index] =
                index >= allTimes.length - hourDiff ? 0 : "-";

              const tableIndex = allTimes.length - index - 1;
              if (!tableData[tableIndex]) {
                tableData[tableIndex] = {};
              }

              const formatType = breakdowns
                ? breakdowns[0].key
                : obj.aggregationPeriod;
              tableData[tableIndex]["title"] = this.dateFormat(t, formatType);
            }
          });
          const timeIndex = acc[metric].date.indexOf(key);
          acc[metric].value[timeIndex] = value;
          tableData[allTimes.length - timeIndex - 1][metric] = valueFormat(
            value,
            metric
          );
          return acc;
        },
        {}
      );
      return { tableData, chartData };
    },
    dateFormat(data, type) {
      if (type === "country") {
        return getCountryName(data);
      } else if (type === "display_format") {
        return this.displayFormat.find(
          (item) => item.value.toLowerCase() === data
        )?.label;
      } else if (type === "property") {
        return this.businessData.find((item) => item.assetId === data)?.appName;
      } else {
        const time = new Date(getTimeToLA(new Date(data).getTime()));
        const ymd = `${time.getFullYear()}-${time.getMonth() + 1
          }-${time.getDate()}`;
        if (type === "hour") {
          return `${ymd} ${time.getHours().toString().padStart(2, "0")}:00`;
        }
        return ymd;
      }
    },
    initTotalData(data, type) {
      let result = {};
      if (type === "hour") {
        for (let key in data) {
          const value = data[key].value;
          const total = value.reduce((count, item) => {
            return item === "-" ? count : count + parseFloat(item);
          }, 0);
          result[key] =
            key.includes("rate") ||
              key === "fb_ad_network_ctr" ||
              key === "fb_ad_network_cpm"
              ? total / value.length
              : total;
        }
      } else {
        result = data.reduce((acc, { metric, value }) => {
          acc[metric] = value;
          return acc;
        }, {});
      }
      this.chartTotalData = result;
    },
    async changeBreakdown(params) {
      const { label, prop } = params;
      this.params.breakdown = prop;
      this.tableData.headConfig.list[0].label = label;
      if (this.tableList.hasOwnProperty(prop)) {
        this.data = this.tableList[prop];
      } else {
        this.isLoadingTable = true;
        const obj = {
          ...this.selectParams,
          ...{
            aggregationPeriod: "total",
            breakdowns: JSON.stringify([this.params.breakdown]),
          },
        };
        let res = await criteriaQueryBusiness(obj);
        this.isLoadingTable = false;
        if (res && res.length > 0) {
          const { tableData } = this.initData(res, obj);
          tableData.sort((a, b) => {
            const value_a = a["fb_ad_network_revenue"] || "$0";
            const value_b = b["fb_ad_network_revenue"] || "$0";
            const m = parseFloat(value_a.replace("$", ""));
            const n = parseFloat(value_b.replace("$", ""));
            return n - m;
          });
          this.data = tableData;
          this.tableList[prop] = tableData;
        } else {
          this.data = [];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.overview-chart {
  width: 100%;
  margin-bottom: 15px;
}

.overview-chart::after {
  content: "";
  display: table;
  clear: both;
}

.overview-head {
  margin: 0 4px 0 4px;
}

.overview-table {
  position: relative;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0ch 0px 5px rgba(0, 0, 0, 0.2);
  padding: 15px;
  margin: 0 4px 5px 4px;

  h1 {
    margin-bottom: 20px;
  }

  .overview-table-select {
    margin-bottom: 15px;

    div {
      float: left;
      height: 40px;
      border-radius: 8px;
      line-height: 40px;
      padding: 0 15px;
      margin-right: 10px;
    }

    div:hover {
      background-color: rgba(244, 244, 249, 1);
      cursor: pointer;
    }

    div.selected {
      background-color: rgba(231, 241, 254, 1);
      color: rgba(23, 113, 237, 1);
    }
  }

  .overview-table-select::after {
    content: "";
    display: table;
    clear: both;
  }
}
</style>
